import React from 'react';
import { Button, Dropdown, Avatar, theme } from 'antd';
import { UserOutlined, DownOutlined, CrownOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

interface UserProfileDropdownProps {
  partnerName?: string;
  isMobile: boolean;
}

const { useToken } = theme;

export const UserProfileDropdown: React.FC<UserProfileDropdownProps> = ({
  partnerName,
  isMobile,
}) => {
  const navigate = useNavigate();
  const { token } = useToken();

  return (
    <Dropdown
      menu={{
        items: [
          {
            key: 'account',
            label: 'Mi cuenta',
            icon: <UserOutlined />,
            onClick: () => navigate('/mi-cuenta'),
          },
          {
            key: 'subscription',
            label: 'Mi suscripción',
            icon: <CrownOutlined />,
            onClick: () => navigate('/mi-suscripcion'),
          },
        ],
      }}
      trigger={['click']}
    >
      <Button
        type="text"
        style={{
          color: token.colorTextBase,
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          height: '40px',
          padding: '4px 8px',
          borderRadius: 8,
        }}
      >
        <Avatar
          size="small"
          icon={<UserOutlined />}
          style={{
            background: 'linear-gradient(135deg, #ff5a00, #ffb020)',
            boxShadow: '0 4px 12px -4px rgba(255,90,0,0.6)',
          }}
        />
        {!isMobile && <span>{partnerName || 'Usuario'}</span>}
        <DownOutlined style={{ fontSize: 10 }} />
      </Button>
    </Dropdown>
  );
};
